import { FindClassificationsToOfflineOutput } from '../../../../../../../../../services/modules/classifications/classifications.types';
import { OfflineDatabaseClassification } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseClassification.types';
import { offlineClassificationsRepository } from '../../../../../../../repositories/offlineClassifications.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class ClassificationsQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    return generateQueryKeysAndFnToPaginatedEndpoint<FindClassificationsToOfflineOutput>({
      url: '/classifications/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineClassificationsRepository.saveAll(data.map(this.toOfflineData));
      },
    });
  }

  private toOfflineData(data: FindClassificationsToOfflineOutput): OfflineDatabaseClassification {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      classificationTypeId: data.classificationTypeId,
    };
  }
}
